import classNames from 'classnames'
import { HTMLAttributes } from 'react'
import styles from './index.module.css'

interface Props extends HTMLAttributes<HTMLDivElement> {
  percent: number
  // For when the caller states the progress in its own words next to the bar.
  hidePercent?: boolean
}

export const ProgressBar = ({ percent, hidePercent, className, ...props }: Props) => {
  return (
    <div className={classNames(styles.container, className)} {...props}>
      <div className={styles.progressWrapper}>
        {/*have to set the width using style prop because tailwind couldn't handle the dynamic width in percentages*/}
        <div style={{ width: `${percent}%` }} className={styles.progressBar} />
      </div>
      {!hidePercent && (
        <div className={styles.percentText}>
          {percent}
          {'%'}
        </div>
      )}
    </div>
  )
}
